import { TranslateResult } from 'vue-i18n';
import i18n from '@/plugins/i18n';
import { DateTime } from 'luxon';

function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const rulesRequired = [
  (v: unknown): boolean | TranslateResult =>
    !!v || i18n.t('rules.campoObrigatorio'),
];

export const rulesBoolean = [
  (v: unknown): boolean | TranslateResult =>
    v === true || v === false || i18n.t('rules.campoObrigatorio'),
];

export const rulesIntegerPositiveNonZero = [
  (v: unknown): boolean | TranslateResult =>
    (!isNaN(Number(v)) && Number.isInteger(Number(v)) && Number(v) > 0) ||
    i18n.t('rules.inteiroPositivoMaiorZero'),
];

export const rulesIntegerPositive = [
  (v: unknown): boolean | TranslateResult =>
    (!isNaN(Number(v)) && Number.isInteger(Number(v)) && Number(v) >= 0) ||
    i18n.t('rules.inteiroPositivo'),
];

export const rulesNumeric = [
  (v: unknown): boolean | TranslateResult =>
    !isNaN(Number(v)) || i18n.t('rules.numerico'),
];

export const rulesNumericPositiveNonZero = [
  (v: unknown): boolean | TranslateResult =>
    (!isNaN(Number(v)) && Number(v) > 0) || i18n.t('rules.numericoPositivo'),
];

export const rulesNumericPositive = [
  (v: unknown): boolean | TranslateResult =>
    (!isNaN(Number(v)) && Number(v) >= 0) ||
    i18n.t('rules.numericoPositivoOuZero'),
];

export const rulesNotEmpty = [
  (v: string): boolean | TranslateResult =>
    (!!v && !!v.trim()) || i18n.t('rules.campoObrigatorio'),
];

export const rulesEmail = [
  (v: string): boolean | TranslateResult =>
    validateEmail(v) || i18n.t('rules.emailInvalido'),
];

export const rulesValidDate = [
  (v: string): boolean | TranslateResult =>
    !v || DateTime.fromISO(v).isValid || i18n.t('rules.dataInvalida'),
];
